// Sponsor data for WUMA 2026 Awards & Prizes page
// Reveal time: 15:00 Philippines time (UTC+8) each day

export const sponsors = {
  liveaboards: [
    {
      id: 1,
      name: "Ondina",
      type: "liveaboard",
      tier: "gold",
      value: 6000,
      destination: "Indonesia",
      prize: "One liveaboard Trip prize + 50% off for a companion",
      revealDate: "2025-12-02",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/ondina.jpg",
      logo: "/images/sponsors/travel/logos/ondina-logo.webp",
      website: "https://thebestdivingintheworld.com/en/",
      description: "Premium liveaboard experience in Indonesia's pristine waters"
    },
    {
      id: 2,
      name: "Aqua By Oniric",
      type: "liveaboard",
      tier: "gold",
      value: 5195,
      destination: "Galapagos",
      prize: "Galapagos 8 Days 7 Night Liveaboard trip",
      revealDate: "2025-12-03",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/aqua-by-oniric.png",
      logo: "/images/sponsors/travel/logos/aqua-by-oniric-logo.webp",
      website: "https://yachtaqua.com/",
      description: "Premium liveaboard experience in Galapagos Biodiversity"
    },
    {
      id: 3,
      name: "iLike",
      type: "liveaboard",
      tier: "gold",
      value: 3000,
      destination: "Indonesia",
      prize: "1x Gold voucher ($1,500)\n3x Normal vouchers ($500 each)",
      revealDate: "2025-12-04",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/ilike.jpg",
      logo: "/images/sponsors/travel/logos/ilike-logo.webp",
      website: "https://ilike-liveaboard.com/",
      description: "World-class diving adventures across Indonesia"
    },
    {
      id: 15,
      name: "The Smiling Seahorse",
      type: "liveaboard",
      tier: "gold",
      value: 2550,
      destination: "Thailand, Burma",
      prize: "One Slot on Blackwater Liveaboard in Burma",
      revealDate: "2025-12-05",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/smiling-seahorse.jpg",
      logo: "/images/sponsors/travel/logos/smiling-seahorse-logo.webp",
      logoSize: "small",
      website: "https://www.thesmilingseahorse.com/",
      description: "Andaman Sea liveaboard: photographer-friendly."
    },
    {
      id: 4,
      name: "Fun Azul",
      type: "liveaboard",
      tier: "gold",
      value: 2500,
      destination: "Maldives",
      prize: "8 Days 7 Night Maldives Liveaboard",
      revealDate: "2025-12-05",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/fun-azul.webp",
      logo: "/images/sponsors/travel/logos/fun-azul-logo.webp",
      website: "https://www.fun-azulfleet.net/areaguide/382",
      description: "Fun Azul is a premium Liveaboard Operator in The Maldives"
    },
  ],
  
  resorts: [
    // RÉVÉLATION 8 DÉCEMBRE (5 resorts ensemble)
    {
      id: 1,
      name: "Azure Dauin",
      type: "resort",
      tier: "gold",
      value: 2100,
      destination: "Dauin, Philippines",
      prize: "2 X 5 Days 4 Nights FB & 8 Boat Dives + 50% discount for companion",
      revealDate: "2025-12-08",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/azure-dauin.jpg",
      logo: "/images/sponsors/travel/logos/azure-dauin-logo.webp",
      website: "https://azurediveresort.com/",
      description: "Azure Resort & Spa is a Boutique hotel on the seafront in Dauin"
    },
    {
      id: 10,
      name: "Atmosphere Dauin",
      type: "resort",
      tier: "gold",
      value: 2500,
      destination: "Dauin, Philippines",
      prize: "5 nights Deluxe Suite B&B for 2 Divers with Dive package 5 days",
      revealDate: "2025-12-06",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/atmosphere-dauin.jpg",
      logo: "/images/sponsors/travel/logos/atmosphere-dauin-logo.webp",
      website: "https://atmosphereresorts.com/",
      description: "Atmosphere Resorts & Spa, with first class amenities and services"
    },
    {
      id: 2,
      name: "Planet Dive Anilao",
      type: "resort",
      tier: "gold",
      value: 1600,
      destination: "Anilao, Philippines",
      prize: "5 Days 4 Nights 8 Dives package stay for 2 Divers Private boat & spotter",
      revealDate: "2025-12-08",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/planet-dive.jpg",
      logo: "/images/sponsors/travel/logos/planet-dive-logo.webp",
      website: "https://www.planetdiveresort.com/",
      description: "Planet Dive is a boutique hotel in Anilao that offers private boats & guides to all divers"
    },
    {
      id: 3,
      name: "NAD Lembeh",
      type: "resort",
      tier: "gold",
      value: 1464,
      destination: "Lembeh, Indonesia",
      prize: "8 Days 7 Nights Dive Package, Beach Front Room, FB, 12 boat Dive Package",
      revealDate: "2025-12-08",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/nad-lembeh.jpg",
      logo: "/images/sponsors/travel/logos/nad-lembeh-logo.webp",
      website: "https://www.nad-lembeh.com/",
      description: "NAD is a Dive Resort in Lembeh with a high level of Underwater Macro Photographer Services"
    },
    {
      id: 4,
      name: "YOS Lembeh",
      type: "resort",
      tier: "gold",
      value: 1317,
      destination: "Lembeh, Indonesia",
      prize: "6 Days 5 Nights in Garden Room with FB 12 Boat Dives",
      revealDate: "2025-12-08",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/yos-lembeh.jpg",
      logo: "/images/sponsors/travel/logos/yos-lembeh-logo.webp",
      website: "https://yosdivelembeh.id/home/",
      description: "Yos Dive is a Boutique hotel on the mainland of Sulawesi, just in front of the Lembeh Strait"
    },
    {
      id: 5,
      name: "Liberty Dive Resort",
      type: "resort",
      tier: "gold",
      value: 1280,
      destination: "Tulamben, Bali",
      prize: "2 X 5 Days 4 Nights in Luxury Garden Cottage B&B 8 Shore Dives",
      revealDate: "2025-12-09",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/liberty-dive.jpg",
      logo: "/images/sponsors/travel/logos/liberty-dive-logo.webp",
      website: "https://www.libertydiveresort.com/",
      description: "Premium diving resort in Tulamben, Bali"
    },
    
    // RÉVÉLATION 9 DÉCEMBRE (4 resorts ensemble)
    {
      id: 6,
      name: "Buceo Anilao",
      type: "resort",
      tier: "gold",
      value: 1184,
      destination: "Anilao, Philippines",
      prize: "7 Days 6 Nights, Sea View Superior B&B + 15 Boat Dives W Nitrox",
      revealDate: "2025-12-09",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/buceo-anilao.jpg",
      logo: "/images/sponsors/travel/logos/buceo-anilao-logo.webp",
      website: "https://buceoanilao.com/",
      description: "Buceo Anilao Beach & Dive Resort is just in front of the Sea"
    },
    {
      id: 7,
      name: "Lembeh Resort",
      type: "resort",
      tier: "gold",
      value: 1142,
      destination: "Lembeh, Indonesia",
      prize: "4 Days 3 Nights, Garden View Room, Full Board & 6 Boat Dives",
      revealDate: "2025-12-09",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/lembeh-resort.jpg",
      logo: "/images/sponsors/travel/logos/lembeh-resort-logo.webp",
      website: "https://www.lembehresort.com/",
      description: "Award-Winning Premier Luxury Resort in Lembeh"
    },
    {
      id: 8,
      name: "Murex Manado",
      type: "resort",
      tier: "gold",
      value: 1058,
      destination: "Manado, Indonesia",
      prize: "4 Days 3 Nights, Deluxe Garden Room Full Board & 6 Boat Dives",
      revealDate: "2025-12-09",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/murex-manado.jpg",
      logo: "/images/sponsors/travel/logos/murex-manado-logo.webp",
      website: "https://murexresorts.com/murex-manado-resort/",
      description: "Home Away From Home, Murex offers a casual & classic stay"
    },
    {
      id: 9,
      name: "Three P Romblon",
      type: "resort",
      tier: "silver",
      value: 670,
      destination: "Romblon, Philippines",
      prize: "3 Days 3 Nights, Standard Room With Full Board & 12 Boat Dives",
      revealDate: "2025-12-09",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/three-p.jpg",
      logo: "/images/sponsors/travel/logos/three-p-logo.webp",
      website: "https://the-three-p.com/",
      description: "The Romblon Reference Resort offers a nice seafront environment and the best spotter of the island"
    },
    // Asiaqua — dotation à venir. Aucun `value` → carte affichée en fin de section
    // (tri par montant décroissant met les sans-valeur en dernier).
    {
      id: 11,
      name: "Asiaqua",
      type: "resort",
      tier: "gold",
      value: 2200,
      destination: "",
      tagline: "Premium Dive Photo Travel Agency",
      prize: "UW photo gear prizes across 11 categories",
      revealDate: "2025-12-01",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      image: "/images/sponsors/travel/asiaqua.png",
      website: "https://asiaqua.com",
      description: "Premium dive photo travel agency and the proud builder of WUMA."
    }
  ],
  
  equipment: [
    {
      id: 1,
      name: "AOI",
      type: "equipment",
      tier: "gold",
      category: "Wet Lens",
      prize: "Underwater Pro Range Box Set: +12.5, +18.5 & +23.5 Close-up Lenses",
      prizeValue: 1550,
      revealDate: "2026-02-28",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      manualRevealOnly: false,  // Revealed
      image: "/images/sponsors/equipment/aoi.jpg",
      logo: "/images/sponsors/equipment/logos/aoi-logo.webp",
      website: "https://www.aoi-uw.com",
      description: "Win the best Wet Lens set on the market"
    },
    {
      id: 2,
      name: "Fotocore",
      type: "equipment",
      tier: "gold",
      category: "Professional Underwater Strobes",
      prize: "2x GTM strobes ($448 each) + 1x OSD snoot ($118) + 1x ST01 torches ($186 each)",
      prizeValue: 752,
      revealDate: "2026-02-28",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      manualRevealOnly: false,  // Revealed
      image: "/images/sponsors/equipment/fotocore.jpg",
      logo: "/images/sponsors/equipment/logos/fotocore-logo.webp",
      website: "https://www.fotocore.com",
      description: "Win the most compact strobes on the market"
    },
    {
      id: 3,
      name: "Marelux",
      type: "equipment",
      tier: "gold",
      category: "Innovative and Exciting Underwater Photo Products",
      prize: "One Apollo S Strobe ($700) & 3 x Artemis 1000 Video Light ($300)",
      prizeValue: 1600,
      revealDate: "2026-02-28",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      manualRevealOnly: false,  // Revealed
      image: "/images/sponsors/equipment/marelux.jpg",
      logo: "/images/sponsors/equipment/logos/marelux-logo.webp",
      website: "https://www.marelux.co",
      description: "Win the fastest recycle time strobe on the market"
    },
    {
      id: 4,
      name: "INON",
      type: "equipment",
      tier: "silver",
      category: "Underwater Quality Equipment",
      prize: "S-220 Strobe (~$400) + UCL-90 Close-up Lens (~$300)",
      prizeValue: 700,
      revealDate: "2026-02-28",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      manualRevealOnly: false,  // Revealed
      image: "/images/sponsors/equipment/inon.jpg",
      logo: "/images/sponsors/equipment/logos/inon-logo.webp",
      website: "https://www.inon.jp",
      description: "Win iconic Japanese precision optics & strobes"
    },
    {
      id: 5,
      name: "OrcaTorch",
      type: "equipment",
      tier: "bronze",
      category: "Personal Lighting Solution",
      prize: "D710V MK2 + ZD710 MK2",
      prizeValue: 355,
      revealDate: "2026-02-28",
      revealTime: "15:00",
      timezone: "Asia/Manila",
      manualRevealOnly: false,  // Revealed
      image: "/images/sponsors/equipment/orcatorch.jpg",
      logo: "/images/sponsors/equipment/logos/orcatorch-logo.webp",
      website: "https://www.orcatorchstore.com",
      description: "Win pro-grade dive lights for stunning underwater shots"
    }
  ]
};

// Calculate total prize value
export const calculateTotalValue = () => {
  // Total prize value = $41,000+ (Jul 2026 update, Asiaqua $2,200 added)
  return 41000;
};

// Get counts
export const getSponsorCounts = () => {
  return {
    liveaboards: sponsors.liveaboards.length,
    resorts: sponsors.resorts.length,
    equipment: sponsors.equipment.filter(e => e.tier !== 'tbc').length
  };
};
